<template>
  <div class="page-content">
    <div class="page-title">Milestones</div>
    <div class="text">
      Milestones of the Birth of the UNESCO Club and the Establishment of the World Federation
    </div>
    <div class="video-view">
<!--      <video controls-->
<!--             src="@/assets/images/about/test.mp4"-->
<!--      ></video>-->
            <video controls
                   src=""
            ></video>
    </div>
    <div class="time-view">
      <div class="time-item" v-for="(item, index) in infoList" :key="index">
        <div class="item-info">
          <div class="info-title">{{item.title}}</div>
          <div class="info-content">{{item.content}}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "strategy",
  components: {},
  data() {
    return {
      infoList: [
        {
          title: "1947",
          content: 'The first UNESCO Club (Association for cooperation of UNESCO) was born in Sendai, Japan on 19th July 1947.',
        },{
          title: "1949",
          content: 'Mr. Jaime Torres Bodet, the 2nd Director General of UNESCO in his address at the Annual Seminar of Directors of Secondary Education at Severs on 4th November 1949 (4th Anniversary Day of UNESCO) launched an appeal to create “Club of Friends of UNESCO” in secondary schools and universities for international understanding.',
        },{
          title: "1954",
          content: 'At the 8th Session of the General Conference, by its Resolution IV.1.5.15, UNESCO encouraged its Member States to create UNESCO Club under the auspicious of their National Commissions.',
        },{
          title: "1970",
          content: 'At the 16th Session of the General Conference, under the Programme and Budget for 1971-1972 (Out-of School Education-Youth activities), Member States were invited to encourage UNESCO Clubs (1.321) and the National Commissions were invited to develop UNESCO Clubs (4.34).',
        },{
          title: "1974",
          content: 'The Asia Pacific Federation of UNESCO Clubs & Associations (AFUCA) was created in Kyoto, Japan in July 1974, with the participation of members from 16 countries. UNESCO Club leaders from 10 European & 6 African countries attended the Constituency Assembly of AFUCA as observers. ADG and officials of other concerned divisions of UNESCO also attended the Assembly.',
        },{
          title: "1976",
          content: 'The 2nd meeting of Asia Pacific Federation of UNESCO Clubs and Associations (AFUCA) was held in Seoul, Korea in June 1976. It initiated to create a World Federation of UNESCO Clubs and Associations (WFUCA). Other meetings in this regard were held in Sofia, Bulgaria in October 1976, in Vienna, Austria in April 1977, and in Paris, France in November 1977. ',
        },{
          title: "1978",
          content: 'The first World Congress of UNESCO Clubs was held at UNESCO Headquarters in Paris during 17-21 April 1978. Mr. Amadou-Mahtar M\'Bow, Director General of UNESCO, opened the Congress. A preparatory committee based on equitable geographical distribution was recommended, with two representatives of each of the 5 regions, plus Japan and Austria. The Preparatory Committee comprises of Ivory Coast, Kenya, Morocco, Tunisia, Bangladesh, Philippines, France, Poland, Equator and Panama.',
        },{
          title: "1978",
          content: 'The 20th session of the General Conference of UNESCO adopted the Resolution 20C/6/32, which invited the Director General and Member States to support the creation of the World Federation of UNESCO Clubs.',
        },{
          title: "1980",
          content: 'By its Resolution 21C/6/04, the 21st Session General Conference of UNESCO paved the way for convening the constitutive congress of WFUCA in 1981 in Room No.1 of UNESCO House in Paris.',
        },{
          title: "1981",
          content: 'The 2nd World Congress of UNESCO Clubs and Associations was held from 29 June to 3 July 1981, at UNESCO Headquarters in Paris. Representatives of UNESCO Clubs and Associations from some 60 countries around the world attended the meeting. The opening speech was delivered by Mr. Federico Mayor, the then Deputy Director-General. \n' +
            '\n' +
            'On 2nd July 1981, the World Congress adopted the constitution submitted by the Preparatory Committee, leading to the official establishment of the World Federation of UNESCO Clubs and Associations, known by its acronym, WFUCA. The General Secretariat of the World Federation was designated to be located in Paris.\n',
        },
      ]
    };
  },
  created() {},
  mounted() {
    const video = document.getElementById("myVideo");
    video.addEventListener("loadedmetadata", function() {
      console.log(111)
      // 获取视频的第一帧画面
      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");
      canvas.width = this.videoWidth;
      canvas.height = this.videoHeight;
      context.drawImage(this, 0, 0, canvas.width, canvas.height);

      // 将画面作为封面设置给视频元素
      video.setAttribute("poster", canvas.toDataURL());
    });
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
.mobile {
  .page-content .time-view {
    &:before {
      display: none;
    }
    .time-item {
      .item-info {
        width: 100%;
        margin-bottom: 20px;
        .info-title {
          text-align: left !important;
        }
      }

    }
  }
}
.page-content {
  display: block !important;
  .time-view {
    color: #2a2a2a;
    padding: fh(40vh, pc) fw(40vw, pc);
    position: relative;
    &:before {
      content: '';
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 1px;
      height: 100%;
      background-color: #ECECEC;
    }
    .time-item {
      display: flex;
      padding-bottom: 20px;
      width: 100%;
      &:nth-child(2n) {
        justify-content: flex-end;
        .item-info {
          .info-title {
            text-align: left;
            &:before {
              left: -48px;
              right: 0;
            }
          }
        }
      }
      .item-info {
        width: calc(50% - 40px);
        .info-title {
          position: relative;
          font-size: fh(42vh, pc);
          line-height: fh(52vh, pc);
          margin-bottom: 20px;
          color: #0077d4;
          text-align: right;
          font-style: oblique;
          &:before {
            content: "";
            width: 18px;
            height: 18px;
            background-color: #0077d4;
            border-radius: 50%;
            position: absolute;
            right: -48px;
            top: 50%;
            transform: translateY(-50%);
          }
        }
        .info-content {
          font-size: fh(14vh, pc);
          line-height: fh(24vh, pc);
          font-weight: 400;
          padding-left: 10px;
        }
      }
    }
  }
  .video-view {
    video {
      width: 100%;
      margin-top: 20px;
    }
  }
  .page-title {
    font-weight: bold;
    font-size: fh(36vh, pc);
    color: #333333;
    line-height: fh(54vh, pc);
    text-align: justify;
    margin-bottom: fh(20vh, pc);
  }
  > img {
    width: 100%;
    display: block;
  }
  .sub-title {
    margin: fh(20vh, pc) 0;
    font-size: fh(24vh, pc);
    line-height: fh(54vh, pc);
    font-weight: bold;
    color: #333333;
  }
  .text {
    // margin-top: fh(55vh, pc);
    font-size: fh(18vh, pc);
    color: #2a2a2a;
    line-height: fh(31vh, pc);
  }
  .more-btn {
    margin: fh(50vh, pc) auto;
  }
}
</style>
